import React from 'react';
import axios from 'axios';
import ShowMoreText from 'react-show-more-text';

import 'react-select/dist/react-select.css';
import 'react-virtualized-select/styles.css'

//var termArr = [];
class ProfileRecomment extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rst: [],
            totalResults: 0,
            itemFeedback: [],
            loading: false,
            profileId: this.props.profileId,
        };
    }

    componentWillMount() {
        this.getFeedback();
    }

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {
        var loading = false;
        if (nextProps.profileId != this.props.profileId) {
            loading = true;
        }
        if (loading) {
            this.setState({
                loading: loading,
                profileId: nextProps.profileId,
            }, () => {
                this.getFeedback();
            });
        }
        else {
            this.setState({profileId: nextProps.profileId});
        }
    }

    getFeedback = () => {
        var url = "/code/api_projects.php?api=getFeedback";
        var data = new FormData();
        data.append('profileId', this.state.profileId);
        axios.post(url, data)
            .then(response => {

                var rst = response.data;

                if (parseInt(rst.status) === 1) {
                    this.setState({ rst: rst, totalResults: rst.totalResults }, () => {
                        this.renderFeedback()
                    });
                }
                else {
                    this.setState({rst: [], itemFeedback: [], totalResults: 0});
                }
            }).catch(error => {
        });
    }

    renderFeedback = () => {
        let rst = this.state.rst;
        if (rst.results !== undefined) {
            var itemFeedback = this.state.itemFeedback;
            var totalResults = rst.totalResults + itemFeedback.length;
            if (totalResults > 0) {
                var i = 0;
                for (var item of rst.results) {
                    var e_profile = item.e_profile
                    i++;
                    var avatar = "/static/img/appimg/common-noavatar-sm.jpg"
                    if (parseInt(e_profile.image_avatar_account) > 0) {
                        avatar = e_profile.avatar
                        while(avatar.charAt(0) === '/')
                        {
                            avatar = avatar.substring(1);
                        }
                        avatar = "/" + avatar;
                    }
                    itemFeedback.push(
                        <div key={"feedback-"+i+item.employer_account}  className={"row item_box_bottom"}>
                            <div className={"col-xs-3"}>
                                <div className="avatar_wrapper no_background">
                                    <img src={avatar}/>
                                </div>
                                <div className="clm_content_wrapper clm_content_left">
                                    {e_profile.full_name}&nbsp;
                                    <p className="major_name">{e_profile.job_title_e_account} at {e_profile.name_company}</p>
                                    <p className="end_date">{item.created_endcontract}</p>
                                </div>
                            </div>
                            <div className={"col-xs-9"}>
                                <ShowMoreText
                                    lines={2}
                                    more='Show more'
                                    less='Show less'
                                    anchorClass=''
                                    onClick={this.executeOnClick}
                                >
                                    {item.comment_puplic_endcontract}
                                </ShowMoreText>
                            </div>
                        </div>
                    );
                }
            }
            else {
                itemFeedback.push(
                    <div key={"tracker-empty"} className="row item_box_bottom">
                        <div className="text-center">Empty</div>
                    </div>
                );
            }
            this.setState({itemFeedback: itemFeedback});
        }
    }

    executeOnClick = (isExpanded) => {
    }

    render() {

        return (
            <div className="page_course_box profile_content_wrapper pubpro_connection">
                <div className="title_box">
                    <img src="/static/img/appimg/icon_recom.png"/>
                    <div className="title">
                        Feedback
                    </div>
                </div>
                <div className={"received-block"}>
                    <span>Received ({this.state.totalResults})</span>
                </div>
				<div className="right_edit_box recomment-block">
					{this.state.itemFeedback}
				</div>
            </div>

        )
    }
}

export default ProfileRecomment;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/profile/profile_recomment.js
 **/